// ORDERS
const SET_ORDER_SALES_REPOORT = 'SET_ORDER_SALES_REPOORT';
const LOADING_ORDER_SALES_REPOORT = 'LOADING_ORDER_SALES_REPORT';
const ORDER_SALES_REPORT_ERROR = 'ORDER_SALES_REPORT_ERROR';

export {
  SET_ORDER_SALES_REPOORT,
  LOADING_ORDER_SALES_REPOORT,
  ORDER_SALES_REPORT_ERROR,
};
